import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-row-with-two-columns',
  templateUrl: './row-with-two-columns.component.html',
  styleUrls: ['./row-with-two-columns.component.scss'],
})
export class RowWithTwoColumnsComponent {
  @Input() breakpoint: Observable<boolean>;

  @Input() rowFxLayoutAlign = 'center center';
  @Input() fxLayoutGap = '0px';

  @Input() column1FxLayoutAlign = 'center center';
  @Input() column2FxLayoutAlign = 'center center';

  @Input() column1FxFlex = '50%';
  @Input() column2FxFlex = '50%';

  @Input() revertOrderOnBreakpoint = false;
}
